import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { QuoteCheckoutComponent } from './components/quote-checkout/quote-checkout.component'
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion'
import { SoldToAddressComponent } from './components/sold-to-address/sold-to-address.component'
import { GuestCheckoutComponent } from './components/guest-checkout/guest-checkout.component'
import { LoggedInUserCheckoutComponent } from './components/loggedIn-user-checkout/loggedIn-user-checkout.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ShipToAddressComponent } from './components/ship-to-address/ship-to-address.component'
import { EndCustomerAddressComponent } from './components/end-customer-address/end-customer-address.component'
import { NotificationAttachmentsComponent } from './components/notification-attachments/notification-attachments.component'
import { ComplianceQuestionsComponent } from './components/compliance-questions/compliance-questions.component'
import { SpinnerModule } from '@spartacus/storefront'
import { NgSelectModule } from '@ng-select/ng-select'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { FileUploadModule } from '../../../shared/components/file-upload/file-upload.module'
import { AddressModule } from '../../../shared/components/address/address.module'
import { ComplianceQuestionsDialogModule } from '../../../shared/dialog-box/compliance-questions-dialog/compliance-questions-dialog.module'
import { environment } from '../../../../environments/environment'

@NgModule({
  declarations: [
    QuoteCheckoutComponent,
    GuestCheckoutComponent,
    LoggedInUserCheckoutComponent,
    SoldToAddressComponent,
    ShipToAddressComponent,
    EndCustomerAddressComponent,
    ComplianceQuestionsComponent,
    NotificationAttachmentsComponent,
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploadModule,
    AddressModule,
    SpinnerModule,
    NgSelectModule,
    ComplianceQuestionsDialogModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['quoteCheckout'],
        },
      },
    }),
    // VSScrollToFirstInvalidModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class QuoteCheckoutModule {}
